import React, { useState } from "react";
import Dropdown from "./components/Dropdown/Dropdown";
import {athcapLogo, striveLogo} from "./consts/consts";
import moment from "moment";
import singleTenantSubcategories from "./single-tenant-subcategories";
import multiTenantSubcategories from "./multi-tenant-subcategories";
import industrialSubcategories from "./single-multi-tenant-industrial-subcategories";
import singleTenantOfficeSubcategories from "./single-tenant-office-subcategories.js";
import multiTenantOfficeSubcategories from "./multi-tenant-office-subcategories.js";
import multiFamilySubcategories from "./multi-family-subcategories";

const cloneDeep = require('lodash.clonedeep');

export function convertPhoneNumber(phone) {
    if (!phone) {
        return '';
    }
    const p = phone.split(/[()\- ]/g);
    return `${p[1]}.${p[3]}.${p[4]}`
}

export function addCommasToNumberAsString(string) {
    if (!string)
        return '';
    let parts = string.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
}

export function addCommasToNumber(number) {
    if (!number || !number.toString())
        return number;
    let parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
}
export function formatEmail(email) {
    var parts = email.split('@');
    var username = parts[0].substr(0, 2).toUpperCase() + parts[0].substr(2);
    var domain = email.includes('@') ? parts[1].replace(/(strivere)(?=\.com$)/i, 'STRIVEre') : '';
    return username + '@' + domain;
}

// data is array of objects
export function calculateTotalColumn(data, key, count = false) {
    return data.reduce((accumulator, currentValue) => {
        let value;
        if (count) {
            value = 1;
        } else {
            value = typeof currentValue[key] === 'string' ? parseFloat(currentValue[key]) : currentValue[key];
        }
        return accumulator + value;
    }, 0);
}

export function getNotEmptyValueCount(data, key) {
    let count = 0;

    data.forEach(obj => {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                
                // Check for non-empty strings, non-zero numbers, and non-null/undefined
                if((value !== null && value !== undefined)){
                    if (
                        obj['transactionType'] === 'Investment Sales' &&
                        ((typeof value === 'string' && value.trim() !== '') ||
                        (typeof value === 'number' && value !== 0))
                        ) {
                        count++;
                        }
                }    
            }
        });

  return count;
}

export function formatPhoneNumber(value) {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;
    if (cvLength < 4) return currentValue || '';
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
}

export function formatNumber(value, isPrice, decimals) {
    if (!value) return value;
    let currentValue = value;
    if (typeof value !== 'string') currentValue = currentValue.toString();
    currentValue = currentValue.replace(/[^\d|.]/g, '');
    if (decimals) return parseFloat(currentValue).toLocaleString(undefined, {maximumFractionDigits: decimals, minimumFractionDigits: decimals});
    if (isPrice) return addCommasToNumberAsString(currentValue);
    return currentValue;
}

export function formatDate(value) {
    if (!value) return value;
    return value.replace(/[^\d|/]/g, '');
}

export function formatAgentPercent(value) {
    if (!value) return value;
    const number = String(value).split('.'); 
    //const number = value.split('.');
    const decimals = number[1] ? number[1].length : null;
    if (decimals && decimals > 15) return value.slice(0, -1);
    return value;
}

export function capitalize(string) {
    if (!string) {
        return '';
    }
    return string[0].toUpperCase() + string.slice(1);
}

// separated by comma
export function capitalizeAll(string) {
    if (!string) {
        return '';
    }
    let array = string.split(',');
    array = array.map(el => capitalize(el));
    return array.join(', ');
}

export function formatName(data, key = '') {
    if (data[`${key}FIRST_NAME`] && data[`${key}LAST_NAME`] && data[`${key}FIRST_NAME`].trim() && data[`${key}LAST_NAME`].trim())
        return `${data[`${key}FIRST_NAME`]} ${data[`${key}LAST_NAME`]}`;
    else {
        if (data[`${key}FIRST_NAME`] && data[`${key}FIRST_NAME`].trim()) return data[`${key}FIRST_NAME`];
        if (data[`${key}LAST_NAME`] && data[`${key}LAST_NAME`].trim()) return data[`${key}LAST_NAME`];
        if (data[`${key}COMPANY_NAME`] && data[`${key}COMPANY_NAME`].trim()) return data[`${key}COMPANY_NAME`];
        if (data[`${key}EMAIL`] && data[`${key}EMAIL`].trim()) return data[`${key}EMAIL`];
    }
    // Must return a string: MUI Autocomplete calls .toLowerCase() on this value
    return '';
}
export function formatNames(data, key = '') {
    if (!data || typeof data !== 'object') return typeof data === 'string' ? data : '';
    if (data[`${key}first_name`] && data[`${key}last_name`] && data[`${key}first_name`].trim() && data[`${key}last_name`].trim())
        return `${data[`${key}first_name`]} ${data[`${key}last_name`]}`;
    else {
        if (data[`${key}first_name`] && data[`${key}first_name`].trim()) return data[`${key}first_name`];
        if (data[`${key}last_name`] && data[`${key}last_name`].trim()) return data[`${key}last_name`];
        if (data[`${key}company_name`] && data[`${key}company_name`].trim()) return data[`${key}company_name`];
        if (data[`${key}email`] && data[`${key}email`].trim()) return data[`${key}email`];
    }
    // Must return a string: MUI Autocomplete calls .toLowerCase() on this value
    return '';
}

export function formatType(type) {
    if (!type)
        return null;
    if (type.includes('STNL') && type.includes('MT') && type.includes('Other'))
        return 'Single-Tenant, Other, Multi-Tenant';
    if (type.includes('STNL') && type.includes('MT'))
        return 'Single-Tenant, Multi-Tenant';
    if (type.includes('STNL') && type.includes('Other'))
        return 'Single-Tenant, Other';
    if (type.includes('MT') && type.includes('Other'))
        return 'Other, Multi-Tenant';
    if (type.includes('STNL'))
        return 'Single-Tenant';
    if (type.includes('MT'))
        return 'Multi-Tenant';
    if (type.includes('Other'))
        return 'Other';
    return null;
}

export function addSpaceAfterComma(string) {
    if (!string) return '';
    let result = cloneDeep(string);
    result = result.replace(/,/g, ', ');
    return result;
}

export function percent(value, decimals = 0) {
    if (value === undefined || value === null || value === '') return '';
    if (decimals) return Number(value).toFixed(decimals)+'%';
    return parseInt(value)+'%';
}

export function formatPropertyName(name, city, state) {
    if (city && state) return `${name} - ${city}, ${state}`;
    if (city) return `${name} - ${city}`;
    if (state) return `${name} - ${state}`;
    return name;
}

// array of objects
export function sortArray(array, key, desc = false) {
    const sortedArray = cloneDeep(array);
    if (key) {
        if (desc) {
            sortedArray.sort((a, b) => (a[key] > b[key]) ? -1 : 1);
        } else {
            sortedArray.sort((a, b) => (a[key] < b[key]) ? -1 : 1);
        }
    } else {
        if (desc) {
            sortedArray.sort((a, b) => (a > b) ? -1 : 1);
        } else {
            sortedArray.sort((a, b) => (a < b) ? -1 : 1);
        }
    }
    return sortedArray;
}

export function formatAddress(address) {
    if (address!= null && address.includes('Farm to Market')) {
        address = address.replaceAll('Farm to Market', 'FM');
    }
    if (address!= null && address.includes('Parkway')) {
        address = address.replaceAll('Parkway', 'Pkwy');
    }
    if (address!= null && address.includes('Farm Road')) {
        address = address.replaceAll('Farm Road', 'FM');
    }
    if (address!= null && address.includes('Road')) {
        address = address.replaceAll('Road', 'Rd');
    }
    if (address!= null && address.includes('Avenue')) {
        address = address.replaceAll('Avenue', 'Ave');
    }
    if (address!= null && address.includes('Boulevard')) {
        address = address.replaceAll('Boulevard', 'Blvd');
    }
    if (address!= null && address.includes('Circle')) {
        address = address.replaceAll('Circle', 'Cir');
    }
    if (address!= null && address.includes('Court')) {
        address = address.replaceAll('Court', 'Ct');
    }
    if (address!= null && address.includes('Street')) {
        address = address.replaceAll('Street', 'St');
    }
    if (address!= null && address.includes('Lane')) {
        address = address.replaceAll('Lane', 'Ln');
    }
    if (address!= null && address.includes('Highway')) {
        address = address.replaceAll('Highway', 'Hwy');
    }
    if (address!= null && address.includes('Expressway')) {
        address = address.replaceAll('Expressway', 'Expy');
    }
    if (address!= null && address.includes('Farm-to-Market') || address!= null && address.includes('Farm to Market')) {
        address = address.replaceAll(/Farm-to-Market|Farm to Market/, 'FM');
    }
    if (address!= null && address.includes('Post Office')) {
        address = address.replaceAll('Post Office', 'PO');
    }
    if (address!= null && address.match(/I\s\d+|I\s-\s\d+/g)) {
        address = address.replaceAll(/I\s-\s|I\s/g, 'I-');
    }
    if (address!= null && address.includes('INTERSTATE')) {
        address = address.replaceAll('INTERSTATE', 'Interstate');
    }
    if (address!= null && address.match(/Interstate\s\d+|Interstate\s-\s\d+|Interstate-\d+/g)) {
        address = address.replaceAll(/Interstate\s-\s|Interstate\s|Interstate-/g, 'I-');
    }
    return address;
}

export function renderPrintFooter(isPrint, isHSC = false) {
    if (!isPrint) {
        return null;
    }
    return (
        <div className={`print-footer ${isHSC ? 'hsc' : ''}`}>
            <div className='logo'>
                <img src={arc.path.media + (isHSC ? athcapLogo : striveLogo)} alt=''/>
            </div>
            {
                isHSC ? '469-844-8024 | athenacapitalre.com' : '(469) 844-8880 | strivere.com'
            }
        </div>
    )
}

export function getWeeks(startDate, endDate) {
    const dayToMs = 1000 * 60 * 60 * 24;
    const days = (endDate - startDate) / dayToMs;
    return Math.floor((days + startDate.getDay()+1) / 7);
}

// for financials tenants
export function findTenantRow(rows, valueKey, value) {
    const keys = Object.keys(rows);
    for (let index = 0; index < keys.length; index++) {
        if (rows[keys[index]].valueCells[valueKey].value === value) return rows[keys[index]];
    }
}

export function formatPipelineTitle(value) {
    if (!value) return;
    if(value == 'total-closed') return "Total Closed";
    let title = value.split('-');
    if (!title[1]) return title[0][0].toUpperCase()+title[0].slice(1);
    return `${title[0][0].toUpperCase()+title[0].slice(1)} ${title[1].toUpperCase()}`;
}

export function getTenantSubcategorySTNL({data, handleChangeDropdown, viewMode=false, deleted=false, theme, className, isFromProperty=false, disabled=false, isFilter=false}) {
    switch (data.category){
        case "office":
            return <Dropdown
                theme={theme}
                className={className}
                data={data}
                isFromProperty={isFromProperty}
                optionsType="singleTenantOffice"
                value={data.single_tenant_subcategory}
                valueKey="single_tenant_subcategory"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
                disabled={disabled}
                isFilter={isFilter}
            />
        case "industrial":
            return <Dropdown
                theme={theme}
                className={className}
                data={data} 
                isFromProperty={isFromProperty}
                optionsType="subcategoryIndustrialSTNLMT"
                value={data.single_tenant_subcategory}
                valueKey="single_tenant_subcategory"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
                disabled={disabled}
                isFilter={isFilter}
            />
        default :
            return <Dropdown
                theme={theme}
                className={className}
                data={data}
                isFromProperty={isFromProperty}
                optionsType="subcategorySTNL"
                value={data.single_tenant_subcategory}
                valueKey="single_tenant_subcategory"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
                disabled={disabled}
                isFilter={isFilter}
            />
    }
}

export function getTenantSubcategoryMT({data, handleChangeDropdown, viewMode=false, deleted=false, theme, className, isFromProperty=false, disabled=false, isFilter=false}) {
    switch (data.category){
        case "office":
            return <Dropdown
                theme={theme}
                className={className}
                data={data}   
                isFromProperty={isFromProperty}
                optionsType="multiTenantOffice"
                value={data.multi_tenant_subcategory}
                valueKey="multi_tenant_subcategory"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
                disabled={disabled}
                isFilter={isFilter}
            />
        case "industrial":
            return <Dropdown
                theme={theme}
                className={className}
                data={data}
                isFromProperty={isFromProperty}
                optionsType="subcategoryIndustrialSTNLMT"
                value={data.multi_tenant_subcategory}
                valueKey="multi_tenant_subcategory"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
                disabled={disabled}
                isFilter={isFilter}
            />
        default :
            return <Dropdown
                theme={theme}
                className={className}
                data={data}
                isFromProperty={isFromProperty}
                optionsType="subcategoryMT"
                value={data.multi_tenant_subcategory}
                valueKey="multi_tenant_subcategory"
                label="Tenant Subcategory"
                handleParentChange={handleChangeDropdown}
                viewMode={viewMode}
                deleted={deleted}
                disabled={disabled}
                isFilter={isFilter}
            />
    }
}

// Tenant subcategory options for one tenant type ('STNL' | 'MT') across every
// selected category. Categories without a dedicated list (retail, other) use
// the same default lists as getTenantSubcategorySTNL/MT above.
// categories can be a comma-separated string of category codes or an array.
export function getTenantSubcategoryOptions(tenantType, categories) {
    const categoryList = Array.isArray(categories)
        ? categories
        : (categories || '').split(',').filter(Boolean);
    const options = [];
    categoryList.forEach((category) => {
        let set;
        switch (category) {
            case 'office':
                set = tenantType === 'MT' ? multiTenantOfficeSubcategories : singleTenantOfficeSubcategories;
                break;
            case 'industrial':
                set = industrialSubcategories;
                break;
            case 'apartments': // Multi-Family; same list for STNL and MT
                set = multiFamilySubcategories;
                break;
            default:
                set = tenantType === 'MT' ? multiTenantSubcategories : singleTenantSubcategories;
        }
        set.forEach((option) => {
            if (!options.includes(option)) options.push(option);
        });
    });
    return options.sort((a, b) => a.localeCompare(b));
}

// Drops subcategory values that are no longer offered for the current
// category/type selection; returns null when nothing valid remains.
export function pruneTenantSubcategories(selected, options) {
    if (!selected) return null;
    const kept = String(selected).split(',').filter((value) => options.includes(value));
    return kept.length ? kept.join(',') : null;
}

/*  Net Commission = 50% of Gross Commission
    55% on any gross commissions over $200,001
    It continues every $200,000 and tops out at 70%
    
    FROM 2026 ONWARDS:
    50% for $0 - $350,000
    55% for $350,001 - $500,000
    60% for $500,001 - $900,000
    65% for $900,001+
 */
export function getPaymentPercentage(grossCumulative, closeDate = null) {
    if (isNaN(grossCumulative))
        return 0;

    // Determine if we should use 2026+ brackets
    let use2026Brackets = false;
    if (closeDate) {
        const date = new Date(closeDate);
        const year = date.getFullYear();
        use2026Brackets = year >= 2026;
    }

    if (use2026Brackets) {
        // 2026+ brackets
        if (grossCumulative <= 350000) return 50;
        if (grossCumulative <= 500000) return 55;
        if (grossCumulative <= 900000) return 60;
        return 65;
    } else {
        // Pre-2026 brackets (legacy)
        var modifier = Math.floor(grossCumulative / 200001);
        if(modifier < 0){
            modifier = 0;
        }
        if (modifier > 4)
            return 50 + 5 * 4;
        return 50 + 5 * modifier;
    }
}

export function getPaymentThreshold(grossCumulative, closeDate = null) {
    // Determine if we should use 2026+ brackets
    let use2026Brackets = false;
    if (closeDate) {
        const date = new Date(closeDate);
        const year = date.getFullYear();
        use2026Brackets = year >= 2026;
    }

    if (use2026Brackets) {
        // 2026+ brackets
        if (grossCumulative > 350000 && grossCumulative <= 500000)
            return 350000;
        if (grossCumulative > 500000 && grossCumulative <= 900000)
            return 500000;
        if (grossCumulative > 900000)
            return 900000;
        return 0;
    } else {
        // Pre-2026 brackets (legacy)
        if (grossCumulative > 200000 && grossCumulative <= 400000)
            return 200000;
        if (grossCumulative > 400000 && grossCumulative <= 600000)
            return 400000;
        if (grossCumulative > 600000 && grossCumulative <= 800000)
            return 600000;
        if (grossCumulative > 800000)
            return 800000;
        return 0;
    }
}
export function getAgentContribution(property, agentId) {
    const agents = {};

    // Listing agents
    if (property.listing_agent_1 && property.listing_agent_1_percent) {
        agents[property.listing_agent_1] = parseFloat(property.listing_agent_1_percent) || 0;
    }
    if (property.listing_agent_2 && property.listing_agent_2_percent) {
        agents[property.listing_agent_2] = (agents[property.listing_agent_2] || 0) + parseFloat(property.listing_agent_2_percent) || 0;
    }
    if (property.listing_agent_3 && property.listing_agent_3_percent) {
        agents[property.listing_agent_3] = (agents[property.listing_agent_3] || 0) + parseFloat(property.listing_agent_3_percent) || 0;
    }

    // Buyer agents
    if (property.buyer_agent_1 && property.buyer_agent_1_percent) {
        agents[property.buyer_agent_1] = (agents[property.buyer_agent_1] || 0) + parseFloat(property.buyer_agent_1_percent) || 0;
    }
    if (property.buyer_agent_2 && property.buyer_agent_2_percent) {
        agents[property.buyer_agent_2] = (agents[property.buyer_agent_2] || 0) + parseFloat(property.buyer_agent_2_percent) || 0;
    }
    if (property.buyer_agent_3 && property.buyer_agent_3_percent) {
        agents[property.buyer_agent_3] = (agents[property.buyer_agent_3] || 0) + parseFloat(property.buyer_agent_3_percent) || 0;
    }
       
    const totalContributions = Object.values(agents).reduce((sum, value) => sum + value, 0);    
    const agentContribution = agents[agentId] || 0;
    return (agentContribution / totalContributions) * 100;
}

export function getCurrentTrancheOnGrossAmount(grossCumulative) {
    if (grossCumulative <= 200000  ) {
        return 0.50;                            
    }else if(grossCumulative>200000 && grossCumulative<=400000 ){
        return 0.55;                             
    }else if(grossCumulative>400000 && grossCumulative<=600000 ){
        return 0.60;                
    }else if(grossCumulative>600000 && grossCumulative<=800000 ){
        return 0.65;                               
    }else if(grossCumulative>800000 ){
        return 0.70;                               
    }
    return 0;
}

export function insertCurrentDataToSortedArray(currentData, sortedArray, filters, weightsArray){  
    let insertIndex = 0, done = false, nextFilter, j = 0;

    //ordered filters
    filters = filters.sort((a, b) => weightsArray.filter(el => el.key === a.split('.')[0])[0].weight > weightsArray.filter(el => el.key === b.split('.')[0])[0].weight ? 1 : -1)
    if(filters.length>0)
        for(let i = 0; i< sortedArray.length && !done; i++) {
            nextFilter=false; j=0;
            while(!nextFilter && !done && j<filters.length) {
                const filter = filters[j].split('.')[0];
                const direction = filters[j].split('.')[1];

                if(currentData[filter]!=null){
                    if(direction === 'asc' && currentData[filter].localeCompare(sortedArray[i][filter], 'en',{numeric: true}) < 0){
                        if(!sortedArray[i][filter])
                            nextFilter = true;
                        else {
                            insertIndex = i;
                            done = true;
                        }
                    }
                    else if(direction === 'desc' && currentData[filter].localeCompare(sortedArray[i][filter], 'en', {numeric: true}) > 0){
                        insertIndex = i;
                        done = true;
                    }
                    else if(direction === 'desc' && currentData[filter].localeCompare(sortedArray[i][filter], 'en', {numeric: true}) < 0 || 
                            direction === 'asc' && currentData[filter].localeCompare(sortedArray[i][filter], 'en', {numeric: true}) > 0){
                        if(!sortedArray[i][filter])
                            done = true;
                        else {
                            insertIndex = i;
                            nextFilter = true;
                        }
                    }
                    else if(currentData[filter].localeCompare(sortedArray[i][filter], 'en', {numeric: true}) === 0 ){
                        insertIndex = i;
                        j++;
                    }
                }
                else{
                    if(direction === 'asc'){
                        insertIndex = i;
                        done=true;
                    } else if(direction === 'desc'){
                        insertIndex = i;
                        nextFilter=true;
                    }
                }
            }
        }
    
    if(!done) {
        insertIndex++;
    } 
    
    sortedArray.splice(insertIndex, 0, currentData);
    return sortedArray;
}

export function getBase64(file) {
    return new Promise(resolve => {
        let baseURL = "";
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
}

export function getHSCCumulativeAgentPercent(grossCumulative) {
    if (grossCumulative >= 0 && grossCumulative <= 250000)
        return 0.5;
    if (grossCumulative > 250000 && grossCumulative <= 500000)
        return 0.55;
    if (grossCumulative > 500000 && grossCumulative <= 750000)
        return 0.6;
    if (grossCumulative > 750000 && grossCumulative <= 1000000)
        return 0.65;
    if (grossCumulative > 1000000)
        return 0.7;
    return 0;
}

export function getHSCCumulativeThreshold(grossCumulative) {
    if (grossCumulative > 250000 && grossCumulative <= 500000)
        return 250000;
    if (grossCumulative > 500000 && grossCumulative <= 750000)
        return 500000;
    if (grossCumulative > 750000 && grossCumulative <= 1000000)
        return 750000;
    if (grossCumulative > 1000000)
        return 1000000;
    return 0;
}
export function removeDuplicateObjects(arr){
    const seen = new Set();
    return arr.filter(obj => {
        const stringfiedObj = JSON.stringify(obj);
        if(!seen.has(stringfiedObj)) {
            seen.add(stringfiedObj);
            return true;
        }
        return false;
    });
}
export function getAgentPercentage(property,agentId){
    let buyerAgent;
    let listingAgent;
    let percentage;
    const buyerAgents = [];
    const listingAgents = [];

    property.BUYER_AGENT_1 !== null ? buyerAgents.push({"agent":property.BUYER_AGENT_1,"agentPercentage":parseFloat(property.BUYER_AGENT_1_PERCENT || 0)}):null;
    property.BUYER_AGENT_2 !== null ? buyerAgents.push({"agent":property.BUYER_AGENT_2,"agentPercentage":parseFloat(property.BUYER_AGENT_2_PERCENT || 0)}):null;
    property.BUYER_AGENT_3 !== null ? buyerAgents.push({"agent":property.BUYER_AGENT_3,"agentPercentage":parseFloat(property.BUYER_AGENT_3_PERCENT || 0)}):null;
    
    property.LISTING_AGENT_1 !== null ? listingAgents.push({"agent":property.LISTING_AGENT_1,"agentPercentage":parseFloat(property.LISTING_AGENT_1_PERCENT || 0)}):null;
    property.LISTING_AGENT_2 !== null ? listingAgents.push({"agent":property.LISTING_AGENT_2,"agentPercentage":parseFloat(property.LISTING_AGENT_2_PERCENT || 0)}):null;
    property.LISTING_AGENT_3 !== null ? listingAgents.push({"agent":property.LISTING_AGENT_3,"agentPercentage":parseFloat(property.LISTING_AGENT_3_PERCENT || 0)}):null;
      
    let countListingAgents = listingAgents.filter(item => item.agent === undefined).length;
    let countBuyerAgents = buyerAgents.filter(item => item.agent === undefined).length;    
    let buyerAgentsTotalPercentage = sumByPropertyName(buyerAgents,'agentPercentage');    
    let listingAgentsTotalPercentage = sumByPropertyName(listingAgents,'agentPercentage');     
    let totalAgentPercentage  = parseFloat(buyerAgentsTotalPercentage) + parseFloat(listingAgentsTotalPercentage);

    if(Math.floor(totalAgentPercentage) === 100 || property.TRANSACTION_TYPE === "Referral"){ 
        buyerAgent = buyerAgents.find(obj => obj.agent.toString() === agentId.toString());
        listingAgent = listingAgents.find(obj => obj.agent.toString() === agentId.toString());        
        percentage = parseFloat(buyerAgent? parseFloat(buyerAgent.agentPercentage):0) + parseFloat(listingAgent?parseFloat(listingAgent.agentPercentage):0);
        
     }else{
        const mergeAgents = buyerAgents.length !== 0 ?buyerAgents.map(obj1 => {
            const matchingObj = listingAgents.find(obj2 => obj2.agent === obj1.agent);
            return matchingObj ? {...obj1,...matchingObj}:obj1;
        }):listingAgents;        
        if(countListingAgents === 3 && countBuyerAgents === 3){
            percentage = 0;
        }else{
            let filteredAgents = mergeAgents.filter(agent => agent.agentPercentage !== 0);
            const agent = filteredAgents.find(propAgent => propAgent.agent.toString() === agentId.toString());    
            percentage = agent? 100/filteredAgents.length : 0;
        }
         
    } 
    return percentage/100;
    
}
export function sumByPropertyName(arr,propertyName){
    if(arr.length === 0 || !propertyName){
        return 0;
    }
    const sum = arr.reduce((accumulator,currentValue) => {
        if(currentValue.hasOwnProperty(propertyName) && typeof currentValue[propertyName] === 'number'){
            return accumulator + currentValue[propertyName];
        }else{
            return accumulator;
        }
    },0);
    return sum;
}

export function filterAgentsByDate(agents, givenYear) {
    return agents.filter(agent => {
        const doomsday = 9999;
        const joiningYear = agent.AGENT_STARTING_DATE ? new Date(agent.AGENT_STARTING_DATE).getFullYear() : doomsday;
        const terminationYear = agent.AGENT_TERMINATION_DATE ? new Date(agent.AGENT_TERMINATION_DATE).getFullYear() : doomsday;
       
        return givenYear >= joiningYear && givenYear <=terminationYear;
    })
}

export function filterAgentsWithoutCommisionInTerminationYear(agents, givenYear) {
    let filteredAgents = []

  for (const agent of agents) {
    const hasZeroFees = (
      parseFloat(agent["BUYING_PROCURED_GROSS_FEE"]) === 0.0 &&
      parseFloat(agent["LISTING_PROCURED_GROSS_FEE"]) === 0.0 &&
      ( !agent["PAID_GROSS_FEE"]  || parseFloat(agent["PAID_GROSS_FEE"]) === 0.0)
    );
    const terminationYear = agent.AGENT_TERMINATION_DATE ? new Date(agent.AGENT_TERMINATION_DATE).getFullYear() : false;

    if (!hasZeroFees || !terminationYear) {
      filteredAgents.push(agent);
    }
  }
  return filteredAgents;

}



export function calculateYearsAndMonths(givenDate) {
    var currentDate = new Date(); // Current date
        
        // Calculate the difference in years
        var yearsDiff = currentDate.getFullYear() - givenDate.getFullYear();
        
        // Calculate the difference in months
        var monthsDiff = currentDate.getMonth() - givenDate.getMonth();
    
        if (currentDate.getDate() < givenDate.getDate()) {
            monthsDiff--;
        }
        
        // Adjust months difference if it's negative
        if (monthsDiff < 0) {
            yearsDiff--; // Subtract 1 year
            monthsDiff += 12; // Add 12 months
        }
    
        if (Number.isNaN(yearsDiff) || Number.isNaN(monthsDiff)) {
            return ''; 
        }
    
    
        if ((yearsDiff < 0)||(yearsDiff === 0 && monthsDiff === 0)) {
            return '0M';
        }
    
        if (yearsDiff === 0 && monthsDiff > 0) {
            return `${monthsDiff}M`;
        }
    
        return `${yearsDiff}Y ${monthsDiff}M`;
  }
export function calculateNextBussinessDay(startingDateString,daysAfter){
      // Input starting date string
      //var startingDateString = "2014-06-19";
  
      // Create a Date object with the starting date string
      var startingDate = new Date(startingDateString);
  
      // Add 90 days to the starting date
      var endDate = new Date(startingDate.getTime() + (daysAfter * 24 * 60 * 60 * 1000));
  
      // Check if the 90th day is a Saturday (6) or Sunday (0)
      if (endDate.getDay() === 6) { // Saturday
          endDate.setDate(endDate.getDate() + 2); // Move to Monday
      } else if (endDate.getDay() === 0) { // Sunday
          endDate.setDate(endDate.getDate() + 1); // Move to Monday
      }
  
      // Extract day, month, and year from the end date
      var day = endDate.getDate();
      var month = endDate.getMonth() + 1; // Months are zero-based
      var year = endDate.getFullYear();
  
      // Pad single-digit day and month with leading zeros if necessary
      day = day < 10 ? '0' + day : day;
      month = month < 10 ? '0' + month : month;
  
      // Form the MM/DD/YYYY format string for the end date
      var formattedEndDate = Number.isNaN(month) && Number.isNaN(day) && Number.isNaN(year)?'': month + '/' + day + '/' + year;
  
     // console.log(formattedEndDate); // Output: 09/17/2014 (for the input starting date "2014-06-19")
      return formattedEndDate;
  }
export function convertDateFormat(dateString){
   
      // Create a Date object with the input date string
      var date = new Date(dateString);
  
      // Extract day, month, and year from the Date object
      var day = date.getDate();
      var month = date.getMonth() + 1; // Months are zero-based
      var year = date.getFullYear();
  
      // Pad single-digit day and month with leading zeros if necessary
      day = day < 10 ? '0' + day : day;
      month = month < 10 ? '0' + month : month;
  
      // Form the MM/DD/YYYY format string
      var formattedDate = month + '/' + day + '/' + year;
      return formattedDate;
  
  }
  export function convertDateFormatYYYYMMDD(dateString) {
    try {
    // Split the date string into components
    let parts = dateString.split('/');
    
    // Reorder the components to YYYY-MM-DD format
    let convertedDate = parts[2] + '-' + parts[0].padStart(2, '0') + '-' + parts[1].padStart(2, '0');
    
    return convertedDate;
    } catch (error) {
        return '';
    }
}
export function formattedDate(dateString) {
    // Regular expression to match YYYY-MM-DD format
    let yyyy_mm_dd_regex = /^\d{4}-\d{2}-\d{2}$/;

    // Regular expression to match MM/DD/YYYY format
    let mm_dd_yyyy_regex = /^\d{2}\/\d{2}\/\d{4}$/;

    // Check if the date string matches either format
    if (yyyy_mm_dd_regex.test(dateString)) {
        // If it's in YYYY-MM-DD format, convert it to MM/DD/YYYY format
        let parts = dateString.split('-');
        return parts[1] + '/' + parts[2] + '/' + parts[0];
    } else if (mm_dd_yyyy_regex.test(dateString)) {
        // If it's already in MM/DD/YYYY format, return it as is
        return dateString;
    } else {
        // If it doesn't match either format, return null or handle the error accordingly
        return null;
    }
}

export function isGivenDateInCurrentYear(dateString) {
    // Parse the given date string into a Date object
    const parts = dateString.split('/');
    const year = parseInt(parts[2], 10);
    const month = parseInt(parts[0], 10) - 1; // Month is 0-based
    const day = parseInt(parts[1], 10);
    const dateObject = new Date(year, month, day);

    // Get the current year
    const currentYear = new Date().getFullYear();
    const isInCurrentYear = dateObject.getFullYear() >= currentYear;  
    return isInCurrentYear;
}
export function getCompanyName(email) {  
    const parts = email.split('@');
    if (parts.length === 2) { 
        const domain = parts[1];
        const companyName = domain.split('.')[0]; 
        return companyName.toLowerCase();
    } else {
        return null; 
    }
}
export function checkUploadAccess(loggedInUserEmail,selectedTeamMemberEmail) {  
    const authorizedEmailList = ["sfnu@strivere.com","JPierson@STRIVEre.com","crussell@strivere.com","jgreen@strivere.com", "dmcneil@strivere.com","ARosowski@STRIVEre.com", "jbavanam@sageitinc.com", "mjudd@strivere.com"];
    const authorizedEmails = authorizedEmailList.map(email => email.toLowerCase());
    if (authorizedEmails.includes(loggedInUserEmail.toLowerCase()) || 
        loggedInUserEmail.toLowerCase() === (selectedTeamMemberEmail && selectedTeamMemberEmail.toLowerCase())) {       
        return false;
    }else{
        return true;
    }
}
export function isValidDate(date) {
    return date instanceof Date && !isNaN(date);
}
export function formatDateString(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    //return `${month}/${day}/${year} ${hours}:${minutes}`;
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
export function formatDateTime(input) {  
    if (!input) {
        return '';
    }
    // Check if input is an ISO 8601 date string
    if (input.includes('T') && input.includes('Z')) {
        const isoDate = new Date(input);
        if (isValidDate(isoDate)) {
            return formatDateString(isoDate);
        }
    }
    // Check if input is in ISO 8601 format without milliseconds
    const isoWithoutMsRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
    if (isoWithoutMsRegex.test(input)) {
        const isoDate = new Date(input);
        if (isValidDate(isoDate)) {
            return formatDateString(isoDate);
        }
    }
    // Check if input is in the format YYYY-MM-DD HH:mm:ss
    const yyyymmddhhmmssRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (yyyymmddhhmmssRegex.test(input)) {
        const date = new Date(input.replace(' ', 'T'));
        if (isValidDate(date)) {
            return formatDateString(date);
        }
    }

    // Check if input is in the format MM/DD/YYYY
    const mmddyyyyRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    if (mmddyyyyRegex.test(input)) {
        const dateParts = input.split('/');
        const month = parseInt(dateParts[0], 10);
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const formattedDate = new Date(`${year}-${month}-${day}`);
        if (isValidDate(formattedDate)) {
            return formatDateString(formattedDate);
        }
    }
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
    // Check if the input matches the ISO format
    if (isoRegex.test(input)) {
        // Convert the ISO format to the desired format
        return input.replace('T', ' ');
    } 

    const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
    // Check if the input matches the specified format
    if (dateTimeRegex.test(input)) {
        //const [date, time] = input.split(' ');    
        const dateTime = input.split(' ');        
        const date = dateTime[0];
        const time = dateTime[1];    
        
        const tempDate = date.split('-');
        const year = tempDate[0];
        const month = tempDate[1];
        const day = tempDate[2];
        //const formattedDate = `${month}/${day}/${year}`;
        //const formattedDate = `${day}-${month}-${year}`;
        const formattedDate = `${year}-${month}-${day}`;
        return `${formattedDate} ${time}`;        
        //return input;
    } 

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    // Check if the input matches the date format
    if (dateRegex.test(input)) {
        // Append '00:00' to the date
        return `${input} 00:00`;
    }

    return 'invalid';
}

export function viewDateTimeFormat(input) {
    if (!input) return ' ';

    // If it's in ISO format (with 'T' and possibly 'Z')
    if (input.includes('T')) {
        const date = new Date(input);
        if (!isNaN(date)) {
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        }
    }

    // Pattern: YYYY-MM-DD
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    if (datePattern.test(input)) {
        const [year, month, day] = input.split('-');
        return `${month}/${day}/${year}`;
    }

    // Pattern: YYYY-MM-DD HH:MM
    const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
    if (dateTimeRegex.test(input)) {
        const [date] = input.split(' ');
        const [year, month, day] = date.split('-');
        return `${month}/${day}/${year}`;
    }

    return ' ';
}


export function convertDateTimeFormatToDate(input) {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    if (datePattern.test(input)) {
        const [year, month, day] = input.split('-');
        return `${month}/${day}/${year}`;
    } 

    // Regular expression to match the format YYYY-MM-DD HH:MM
    // const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
     const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/;

    if (dateTimeRegex.test(input)) {
        const [date,time] = input.split(' ');
        const [year, month, day] = date.split('-');
        const formattedDate = `${month}/${day}/${year}`;
        return `${formattedDate}`;
    }
     return input; 
}

export function formatToDateOnly(input) {
    if (!input || typeof input !== 'string') return '';

    // Try to split by space and return only the date part
    const [datePart] = input.split(' ');
    
    // Validate it matches YYYY-MM-DD
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    return dateRegex.test(datePart) ? datePart : '';
}

export function formatDateTimeString(dateTimeString) {
    if (isValidDateTimeFormat(dateTimeString)) {
        const datePart = dateTimeString.split(' ')[0];
        return datePart;
    } else {
        return dateTimeString;
    }
}
export function isValidDateTimeFormat(dateTimeString) {
    // Regular expression to match the YYYY-MM-DD HH:MM format
    const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])\s([01]\d|2[0-3]):([0-5]\d)$/;
    if (!regex.test(dateTimeString)) {
        return false;
    }
    const [datePart, timePart] = dateTimeString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute] = timePart.split(':').map(Number);

    const date = new Date(year, month - 1, day, hour, minute);

    return date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day &&
           date.getHours() === hour && date.getMinutes() === minute;
}


export function isValidPriceChange(value="") {
    if(typeof value === 'number' && !isNaN(value)){
        return value.toFixed(2) +"%";
    }
    return "-";
}

export function compareDates(a,b){
    const dateA = new Date(a.CLOSE_OF_ESCROW);
    const dateB = new Date(b.CLOSE_OF_ESCROW);
    return dateA - dateB;
}

export const formatPrice = (amount) => {
  if (amount == null || isNaN(amount)) {
    return ""; // Return a default value if the value is null, undefined, or NaN
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

export const formatSquareFootage = (value) => {
    if (value == null || isNaN(value)) {
      return " - "; // Return a default value if the value is null, undefined, or NaN
    }
    const roundedValue = Math.round(value);
    return `${roundedValue.toLocaleString()} Sq Ft`;
    // return value.toFixed(0) + " Sq Ft";
  };
    

export function useDebounce(callback, delay) {
    const [timeoutId, setTimeoutId] = useState(null);
  
    return (...args) => {
      // Clear the previous timeout to reset the debounce timer
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
  
      // Set a new timeout to call the callback after the specified delay
      const newTimeoutId = setTimeout(() => {
        callback(...args);
      }, delay);
  
      // Save the timeout ID to clear it on the next call
      setTimeoutId(newTimeoutId);
    };
  }

  export function formatDateInput(value) {
    if (!value) return ""; // Return empty string if no value is present

    // Remove all non-digit characters
    value = value.replace(/[^\d]/g, '');

    // Format as MM/DD/YYYY
    if (value.length > 2) value = value.slice(0, 2) + '/' + value.slice(2);
    if (value.length > 5) value = value.slice(0, 5) + '/' + value.slice(5);

    // Restrict to MM/DD/YYYY format (10 characters)
    return value.slice(0, 10);
}

export function formatNotesDateTime(inputDate) {
    if (!inputDate) return ""; //  Prevent crash if value missing

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return ""; // Prevent invalid date crash

    const options = { 
        month: 'numeric', 
        day: 'numeric', 
        year: 'numeric', 
        hour: 'numeric', 
        minute: 'numeric', 
        hour12: true
    };

    const formattedDate = date.toLocaleString('en-US', options);
    const parts = formattedDate.split(', ');

    if (parts.length < 2) return formattedDate; //  Fallback if unexpected format

    let [month, day, year] = parts[0].split('/');

    //  Make sure they exist and convert to string before pad
    month = String(month || "").padStart(2, '0');
    day = String(day || "").padStart(2, '0');

    return `${month}/${day}/${year} ${parts[1]}`;
}

export function convertKeysToLowerCase(obj) {   
      return Object.keys(obj).reduce((acc, key) => {      
        acc[key.toLowerCase()] = obj[key]; return acc; }, {}); 
    }

      export function updateParams(params, key) {
    if (params) {
        if(params[`${key}_1`]){
            params[key] = [];
            let i = 1;
            while (params[`${key}_${i}`]) {
                let chekingKey = `${key}_${i}`;

                if (params[chekingKey] && params[chekingKey] !== "NOMATCH") {
                    params[key].push(params[chekingKey]);  
                }
                i++;
            }
            for (let j = 1; j <= i; j++) {
                if (params[`${key}_${j}`]){
                    delete params[`${key}_${j}`];
                }
            }
            return params;
        }
        else{
            return params
        }
        
    }
}


export function addDaysSkippingWeekends(startDate, daysToAdd) {
    let currentDate = moment(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
        currentDate = currentDate.add(1, 'days'); // Add one day at a time

        // Skip if the current day is Saturday (6) or Sunday (7)
        if (currentDate.isoWeekday() !== 6 && currentDate.isoWeekday() !== 7) {
            addedDays++;
        }
    }

    return currentDate;
}

export function numberToWords(num = 0) {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 
        'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const units = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    if (num === 0) return 'Zero Dollars';

    const [integerPart, decimalPart] = num.toString().split('.'); // Split decimal parts for calculating cents

    let words = '';
    let unitIndex = 0;
    let intNum = parseInt(integerPart, 10);

    // Process integer part
    while (intNum > 0) {
        let chunk = intNum % 1000;
        if (chunk > 0) {
            let chunkWords = '';
            if (chunk > 99) {
                chunkWords += a[Math.floor(chunk / 100)] + ' Hundred ';
                chunk %= 100;
            }
            if (chunk > 19) {
                chunkWords += b[Math.floor(chunk / 10)] + ' ';
                chunk %= 10;
            }
            if (chunk > 0) {
                chunkWords += a[chunk] + ' ';
            }
            words = chunkWords + units[unitIndex] + ' ' + words;
        }
        intNum = Math.floor(intNum / 1000);
        unitIndex++;
    }

    words = words.trim() + ' Dollars';

    if (decimalPart) {
        let decimalWords = '';
        for (let i = 0; i < decimalPart.length; i++) {
            decimalWords += a[parseInt(decimalPart[i], 10)] + ' ';
        }
        words += ' and ' + decimalWords.trim() + ' Cents';
    }

    return words;
}

export function convertToWords(value='') {
    const num = parseInt(value.toString().replace(` Days`, ''), 10);
    const ones = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
    const teens = ["", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
    const tens = ["", "ten", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

    if (num === 0) return "zero";
    if (num < 10) return ones[num];
    if (num > 10 && num < 20) return teens[num - 10];
    if (num % 10 === 0) return tens[Math.floor(num / 10)];

    return tens[Math.floor(num / 10)] + " " + ones[num % 10];
}

const emailSet = new Set([
  "sfnu@strivere.com",
  "jpierson@strivere.com",
  "jgreen@strivere.com",
  "crussell@strivere.com",
  "tparrish@strivere.com",
  "mgornell@strivere.com",
  "arosowski@strivere.com",
  "aschutte@strivere.com",
  "cbandy@strivere.com",
  "jodulio@strivere.com",
  "jbavanam@sageitinc.com",
  "lzeba@strivere.com",
  'ykeshavjee@strivere.com',
  'mdiaz@strivere.com'
]);

export function isAuthorizedUserForWebsiteChanges(email) {
    if(!email) return
    return emailSet.has(email.toLowerCase());
}

// Users permitted to delete/remove training tiles (Brokerage Continuum).
// Compared case-insensitively against the logged-in user's email.
// Add more emails here to grant additional people delete access.
const trainingDeleteAuthorizedEmails = new Set([
  "jpierson@strivere.com",
  "jbavanam@sageitinc.com",
  "jbavanam@strivere.com",
]);

export function isAuthorizedForTrainingDelete(email) {
    if (!email) return false;
    return trainingDeleteAuthorizedEmails.has(email.toLowerCase());
}
export function getUserType(storedUserData) {
  return storedUserData && storedUserData.type
    ? storedUserData.type.toLowerCase()
    : "";
}
export function isAgentUser(storedUserData) {
  return getUserType(storedUserData) === "agent";
}
export function isSeniorAgent(storedUserData) {
  return getUserType(storedUserData) === "senior agent";
}
export function getYearsAndMonthsFromDate(dateStr) {
    const [month, day, year] = dateStr.split('/').map(Number);
    const inputDate = new Date(year, month - 1, day);
    const today = new Date();
  
    let years = today.getFullYear() - inputDate.getFullYear();
    let months = today.getMonth() - inputDate.getMonth();
  
    // Adjust for partial months
    if (today.getDate() < inputDate.getDate()) {
      months--;
    }
  
    if (months < 0) {
      years--;
      months += 12;
    }
  
    return `${years}Y ${months}M`;
  }

export function getCompletedYearsAndMonths(startStr, endStr) {
  if (!startStr || !endStr) return "";

  const [startMonth, startDay, startYear] = startStr.split("/").map(Number);
  const [endMonth, endDay, endYear] = endStr.split("/").map(Number);

  const startDate = new Date(startYear, startMonth - 1, startDay);
  const endDate = new Date(endYear, endMonth - 1, endDay);

  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();

  // Adjust if end month is before start month
  if (months < 0) {
    years--;
    months += 12;
  }

  //  Adjust for days (only count FULL months)
  if (endDay < startDay) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  return `${years}Y ${months}M`;
}


  export const getIsoDate = (date) => {
    const [mm, dd, yyyy] = date.split('/');
    return `${yyyy}-${mm}-${dd}`;
  };
  export function formatDateToMMDDYYYY(isoDate) {
    if (!isoDate) return '';
    const [year, month, day] = isoDate.split('-');
    return `${month}/${day}/${year}`;
  }

  export function groupObjectByIndex(obj) {
    const result = {};
    const allowed = ["product_type", "territory_market", "territory"];
  
    Object.entries(obj).forEach(([key, value]) => {
      const match = key.match(/^(\w+?)_(\d+)$/); // e.g. "product_type_1"
      if (match) {
        const base = match[1]; // product_type
        const index = match[2]; // 1, 2, etc.
  
        if (allowed.includes(base)) {
          if (!result[index]) result[index] = {};
          result[index][`${base}_${index}`] = value;
        }
      }
    });
  
    return Object.values(result);
  }
  export function format_arcimedes_modified_Date(dateString) {
  if (!dateString) return null;

  const date = new Date(dateString);
  if (isNaN(date)) return null;

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export function getDurationInMonths(startStr, terminationStr, modifiedStr) {
  if (!startStr) return 0;

  const endStr = terminationStr || format_arcimedes_modified_Date(modifiedStr);
  if (!endStr) return 0;

  const [sMonth, sDay, sYear] = startStr.split("/").map(Number);
  const [eMonth, eDay, eYear] = endStr.split("/").map(Number);

  const start = new Date(sYear, sMonth - 1, sDay);
  const end = new Date(eYear, eMonth - 1, eDay);

  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();
  let days = end.getDate() - start.getDate();

  if (days < 0) months -= 1;
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  return years * 12 + months; // total months for sorting
}

export function getFormattedDateTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatDateTimeWithHours(dateTimeString) {
  if (!dateTimeString) return "";

  // Convert "YYYY-MM-DD HH:mm:ss" → "YYYY-MM-DDTHH:mm:ss"
  const isoString = dateTimeString.replace(" ", "T");

  const date = new Date(isoString);

  if (isNaN(date.getTime())) {
    console.error("Invalid date:", dateTimeString);
    return "";
  }

  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return new Intl.DateTimeFormat("en-US", options).format(date);
}

// Format date as YYYY-MM-DD HH:mm:ss
export const getNowDate = () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(
      now.getHours()
    )}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  };

  export function formatUserName({ firstName, lastName, username }) {
  if (firstName && lastName) {
    // Both → capitalize and concatenate (no space)
    const first =
      firstName.charAt(0).toUpperCase() + firstName.slice(1);
    const last =
      lastName.charAt(0).toUpperCase() + lastName.slice(1);
    return `${first} ${last}`;
  } else if (firstName) {
    // Only first
    return firstName.charAt(0).toUpperCase() + firstName.slice(1);
  } else if (lastName) {
    // Only last
    return lastName.charAt(0).toUpperCase() + lastName.slice(1);
  } else if (username) {
    // Only username
    if (username.includes(" ")) {
      // Capitalize each word
      return username
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
    // Capitalize first 2 letters
    return username.slice(0, 2).toUpperCase() + username.slice(2);
  }
  return "";
}

export const getDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("deviceId", deviceId);
  }

  return deviceId;
};
export const getDeviceInfo = () => {
  const deviceId = getDeviceId();

  const uaData = navigator.userAgentData;

  return {
    deviceId,
    userAgent: navigator.userAgent,

    // modern replacement
    platform: uaData ? uaData.platform : "unknown",

    language: navigator.language,
    screen: `${window.innerWidth}x${window.innerHeight}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};

// Notes loaded through Apollo carry __typename (and server-managed fields)
// that ContactNotesInput rejects with a 400 - strip them before mutating.
export function sanitizeNotesForInput(notes) {
  if (!Array.isArray(notes)) return [];
  return notes.map(
    ({
      __typename,
      arcimedes_created,
      arcimedes_created_by,
      arcimedes_modified,
      arcimedes_modified_by,
      temp_id,
      date,
      ...rest
    }) => rest
  );
}